import {Injectable} from '@angular/core';
import {Categories, Configuration, InitialData, Tenant} from "../../interfaces/app";

@Injectable({
  providedIn: 'root',
})
export class AppDataService {
  private _initialData: InitialData;

  get initialData(): InitialData {
    return this._initialData
  }

  set initialData(data: InitialData) {
    this._initialData = data;
  }

  private _configuration: Configuration;

  get configuration(): Configuration {
    return this._configuration;
  }

  set configuration(data: Configuration) {
    this._configuration = data;
  }

  private _tenants: Tenant;

  get tenants(): Tenant {
    return this._tenants;
  }

  set tenants(data: Tenant) {
    this._tenants = data;
  }

  private _categories: Categories;

  get categories(): Categories {
    return this._categories;
  }

  set categories(data: Categories) {
    this._categories = data;
  }

  private _tenantShowRoomConfig: Categories;

  get tenantShowRoomConfig(): any {
    return this._tenantShowRoomConfig;
  }

  set tenantShowRoomConfig(data: any) {
    this._tenantShowRoomConfig = data;
  }

  private _shopSettingData: Categories;

  get shopSettingData(): any {
    return this._shopSettingData;
  }

  set shopSettingData(data: any) {
    this._shopSettingData = data;
  }

}

